import React from 'react';
import { Link } from '@tanstack/react-router';

import type { User } from '../../../types/user';

const DashboardAdminUser: React.FC<{ user: User, handleDeleteUser: Function }> = ({ user, handleDeleteUser }) => {
  const deleteUser = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    handleDeleteUser(user);
  };

  return (
    <tr className="dashboard-admin-user">
      <td>{user.created_at}</td>
      <td>{user.email}</td>
      <td>{user.name}</td>
      <td>
        <div>{user.plan}</div>
        {user.payment_period && (
          <small className="dashboard-admin-user-plan-period">
            {user.payment_period === 'year' ? 'yearly' : 'monthly'}
          </small>
        )}
      </td>
      <td>
        <Link to={`/dashboard/admin/users/${user.id}/sprks`}>
          {user.sprks_count}
        </Link>
      </td>
      <td>
        <Link to={`/dashboard/admin/users/${user.id}/memories`}>
          {user.memories_count}
        </Link>
      </td>
      <td>
        <Link to={`/dashboard/admin/users/${user.id}/timelines`}>
          {user.timelines_count}
        </Link>
      </td>
      <td>
        <Link to={`/dashboard/admin/users/${user.id}/shares`}>
          {user.shares_count}
        </Link>
      </td>
      <td className="actions">
        <div className="wa-cluster wa-gap-2xs">
          <Link to={`/dashboard/admin/users/${user.id}/edit`} id={`user-${user.id}-edit`}>
            <i className="fa-light fa-edit" />
          </Link>
          <wa-tooltip for={`user-${user.id}-edit`} placement="top">
            Edit user
          </wa-tooltip>
          <Link to="#delete" id={`user-${user.id}-delete`} onClick={deleteUser}>
            <i className="fa-light fa-trash" />
          </Link>
          <wa-tooltip for={`user-${user.id}-delete`} placement="top">
            Delete user
          </wa-tooltip>
        </div>
      </td>
    </tr>
  );
}

export default DashboardAdminUser;
